import { FileType } from '@/helpers/fileHelper';

import { SERVICE_CODES } from '@/lib/consts';

export const SERVICE_CODE = SERVICE_CODES.EXTRACT_REDELIVERY;
export const STEP_NUMBER_TO_PAY = 4;

export const missingPersonExtractAllowedFileTypes = [
  FileType.JPEG,
  FileType.PNG,
  FileType.SVG,
  FileType.HEIF,
  FileType.HEIC,
  FileType.PDF,
];
